import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiTreeView {
    constructor() {

    }

    addTreeViewNode() {
    }

    collapseTreeViewNode() {
    }

    countTreeViewNodes() {
    }

    createTreeView() {
    }

    expandTreeViewNode() {
    }

    freeTreeViewNode() {
    }

    insertTreeViewNode() {
    }

    modifyTreeViewNode() {
    }

    selectedTreeViewNode() {
    }

    selectTreeViewNode() {
    }

    treeViewNodeText() {
    }

    treeViewRoot() {
    }
}
